import * as React from 'react';
import { Text } from 'ui';
import { prefixClassName } from 'framework/components/ui/_conf';
import { i18n } from 'i18n';

export type FileRejectionItemProps = {
  file: File;
  errors: Array<{ code: string; message: string }>;
};

export const FileRejectionItem = ({ file, errors }: FileRejectionItemProps) => {
  const cssClass = prefixClassName('file-manager');

  return (
    <div key={file.name}>
      <div className={`${cssClass}__error-title`}>
        <Text caption="modules.contentmanagement.uploadFailed" /> {file.name}
      </div>
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </div>
  );
};

export const FileValidator = (file) => {
  const acceptedMimeTypes = {
    '.pdf': 'application/pdf',
    '.jpg': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.png': 'image/png',
    '.tiff': 'image/tiff',
    '.bmp': 'image/bmp',
    '.gif': 'image/gif',
    '.svg': 'image/svg+xml',
    '.webp': 'image/webp',
    '.eps': 'application/postscript',
    '.mov': 'video/quicktime',
    '.mp4': 'video/mp4',
    '.wmv': 'video/x-ms-wmv',
    '.doc': 'application/msword',
    '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    '.xls': 'application/vnd.ms-excel',
    '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.ppt': 'application/vnd.ms-powerpoint',
    '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  };

  const acceptedTypesArray = Object.keys(acceptedMimeTypes);

  const fileExtension = acceptedTypesArray.find((ext) => file.name.toLowerCase().endsWith(ext));
  if (!fileExtension || file.type !== acceptedMimeTypes[fileExtension]) {
    return {
      code: 'file-invalid-type',
      message: `${i18n.t('modules.contentmanagement.fileTypeError')} ${acceptedTypesArray.join(', ')}`,
    };
  }

  return null;
};
